<section class="px-4 websites_managment">
  <div class="d-flex justify-content-between align-items-center">
    <div class="page_header d-flex">
      <button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1 class="page_header_title" translate>Accordion Details</h1>
    </div>
    <button mat-flat-button color="primary" (click)="addAccordion()">
      <mat-icon>add</mat-icon>
      <span translate>Add Accordion</span>
    </button>
  </div>

  <div class="list-container p-3" [class.loading]="isLoading()">
    <div *ngIf="accordionItems().length > 0">
      <app-expansion-panel
        [items]="accordionItems()"
        (itemExpanded)="onItemExpanded($event)"
        (itemCollapsed)="onItemCollapsed($event)"
        [selectedId]="selectedId()"
        (actionClicked)="onAction($event)"
        (filesReordered)="onFilesReordered($event)"
      ></app-expansion-panel>
    </div>

    <div
      class="empty-data d-flex flex-column align-items-center justify-content-center"
      *ngIf="accordionItems().length === 0 && !isLoading()"
    >
      <i class="fa-solid fa-inbox empty-icon"></i>
      <h3 translate>No accordion items yet</h3>
      <p translate>Start by creating your first accordion section.</p>
    </div>

    <div
      class="d-flex flex-column align-items-center justify-content-center"
      *ngIf="isLoading()"
    >
      <mat-spinner diameter="56"></mat-spinner>
      <span>Loading content...</span>
    </div>
  </div>
</section>
